import { render, staticRenderFns } from "./AreaMangment.vue?vue&type=template&id=4e5026c8&"
import script from "./AreaMangment.vue?vue&type=script&lang=js&"
export * from "./AreaMangment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports